import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';

function CategoryCard({ category }) {
  const { name, image, path, description } = category;

  return (
    <Paper
      component={RouterLink}
      to={path}
      elevation={0}
      sx={{
        position: 'relative',
        height: 300,
        overflow: 'hidden',
        borderRadius: 2,
        textDecoration: 'none',
        display: 'block',
        '&:hover': {
          '& .category-image': {
            transform: 'scale(1.08)',
          },
          '& .category-overlay': {
            bgcolor: 'rgba(26, 54, 93, 0.7)',
          },
        },
      }}
    >
      {/* Background image */}
      <Box
        className="category-image"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          transition: 'transform 0.4s ease-in-out',
        }}
      />

      {/* Overlay */}
      <Box
        className="category-overlay"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: 'rgba(26, 54, 93, 0.5)',
          transition: 'background-color 0.3s ease-in-out',
        }}
      />

      {/* Content */}
      <Box
        sx={{
          position: 'relative',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          p: 3,
          color: 'white',
        }}
      >
        <Typography
          variant="h4"
          component="h3"
          sx={{
            fontWeight: 600,
            mb: 1,
          }}
        >
          {name}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            opacity: 0.9,
            maxWidth: '90%',
          }}
        >
          {description}
        </Typography>
      </Box>
    </Paper>
  );
}

export default CategoryCard;
